export default "__VITE_ASSET__Bsuh8N5w__"